import { StyleSheet } from 'react-native'

const useStyles = (theme) => StyleSheet.create({
  inputsContainer: {
    flexDirection: 'row'
  },
  dayOfWeek: {
    flex: 1,
    marginRight: 10
  },
  quantity: {
    width: 60,
    marginRight: 10
  },
  equipmentType: {
    flex: 1
  },
  checkbox: {
    flexDirection: 'row'
  },
  teamsLabel: {
    alignSelf: 'center'
  }
})

export default useStyles
